import request from '@/router/axios';

export const getList = (current, size, params, search) => {
    return request({
        url: '/api/blade-loanCredentialManagement/loanCredentialManagement/credentialListPage',
        method: 'post',
        data: {
            ...params,
            ...search,
            current,
            size
        }
    })
}
export const getHadList = (current, size, params, search) => {
    return request({
        url: '/api/blade-loanCredentialManagement/loanCredentialManagement/beInStoragePage',
        method: 'post',
        data: {
            ...params,
            ...search,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanCredentialManagement/loanCredentialManagement/update',
        method: 'post',
        data: row
    })
}

export const updateImport = (row) => {
    return request({
        url: '/api/blade-loanCredentialManagement/loanCredentialManagement/submit',
        method: 'post',
        data: row
    })
}

export const getLoanStorageLocationManagement = (type) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/list/' + type,
        method: 'get'
    })
}


export const exportData = (data) => {
    return request({
        url: `/api/blade-loanSecurityDept/loanSecurityDept/export-loanSecurityDept`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}